import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faMagnifyingGlass,
  faCartShopping,
  faFileArrowUp,
  faXmark,
  faQuestion,
  faExclamationTriangle,
  faBars,
  faCheck,
  faArrowUpFromBracket,
  faEllipsisVertical,
  faGauge,
  faUser,
  faKey,
  faSignInAlt,
  faLightbulbOn,
  faIdCard,
  faPause,
  faPlay,
  faSplit,
  faSendBackward,
  faFilter,
  faEnvelopeDot,
  faHouse,
  faListCheck,
  faAddressCard,
  faBuilding,
  faCalendarDays,
  faScreenUsers,
  faGraduationCap,
  faChartPie,
  faWallet,
  faCalculatorSimple,
  faCarBuilding,
  faUserNurse,
  faClock,
  faArrowDown,
  faCoins,
  faPlus,
  faX,
  faCircle,
  faFlag,
  faGear,
  faPaperPlane,
  faExclamation,
  faStopwatch,
  faCar,
  faMotorcycle,
  faBullseyeArrow,
  faFaceSunglasses,
  faArrowUp,
  faFile,
  faWavePulse,
  faBoxArchive,
  faLink,
  faBan,
  faExclamationCircle,
  faFilePlus,
  faSignOut,
  faBook,
  faBookBookmark,
  faChalkboardUser,
  faBallotCheck,
  faGears,
  faPaste,
  faCircleCheck,
  faArrowCircleLeft,
  faArrowCircleRight,
  faArrowCircleDown,
  faFileAlt,
  faThumbsUp,
  faThumbsDown,
  faHourglass,
  faDisplay,
  faRoad,
  faTrafficCone,
  faBrakeWarning,
  faHand,
  faArrowRotateRight,
  faTurnDownRight,
  faTurnDownLeft,
  faSquareParking,
  faAlt,
  faArrowUpToLine,
  faFaceSmile,
  faFaceMeh,
  faFaceFrown,
} from "@fortawesome/pro-solid-svg-icons";

library.add(
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faMagnifyingGlass,
  faCartShopping,
  faFileArrowUp,
  faXmark,
  faQuestion,
  faExclamationTriangle,
  faBars,
  faCheck,
  faArrowUpFromBracket,
  faGauge,
  faEllipsisVertical,
  faUser,
  faKey,
  faSignInAlt,
  faLightbulbOn,
  faPause,
  faPlay,
  faSplit,
  faSendBackward,
  faFilter,
  faEnvelopeDot,
  faHouse,
  faListCheck,
  faAddressCard,
  faBuilding,
  faCalendarDays,
  faScreenUsers,
  faGraduationCap,
  faChartPie,
  faWallet,
  faIdCard,
  faCalculatorSimple,
  faCarBuilding,
  faUserNurse,
  faClock,
  faArrowDown,
  faCoins,
  faPlus,
  faX,
  faCircle,
  faFlag,
  faGear,
  faPaperPlane,
  faExclamation,
  faStopwatch,
  faCar,
  faMotorcycle,
  faBullseyeArrow,
  faFaceSunglasses,
  faArrowUp,
  faFile,
  faWavePulse,
  faBoxArchive,
  faLink,
  faBan,
  faExclamationCircle,
  faFilePlus,
  faSignOut,
  faBook,
  faBookBookmark,
  faDisplay,
  faChalkboardUser,
  faBallotCheck,
  faGears,
  faPaste,
  faCircleCheck,
  faArrowCircleLeft,
  faArrowCircleRight,
  faArrowCircleDown,
  faFileAlt,
  faThumbsUp,
  faThumbsDown,
  faHourglass,
  faRoad,
  faTrafficCone,
  faBrakeWarning,
  faHand,
  faArrowRotateRight,
  faTurnDownRight,
  faTurnDownLeft,
  faSquareParking,
  faAlt,
  faArrowUpToLine,
  faFaceSmile,
  faFaceMeh,
  faFaceFrown
);
